"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var utils_1 = require("../utils");
function FieldErrorMessage(_a) {
    var errors = _a.errors, name = _a.name;
    if (errors === undefined)
        return null;
    var error = (0, utils_1.getError)(errors, name);
    if (error.message !== "") {
        return (0, jsx_runtime_1.jsx)("small", { className: "text-fi-danger text-xs font-light mt-2", children: error.message });
    }
    return null;
}
exports.default = FieldErrorMessage;
